module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes"}
// module id = 1
// module chunks = 0 1 2 3 4 5